import { fetchAuthSession } from 'aws-amplify/auth'
import { jwtDecode } from 'jwt-decode'
import { MixpanelManager } from '../Mixpanel/mixpanelManager'

const getIDToken = async () => {
  if (!isTokenValid('ID_TOKEN')) {
    await updateTokensToStorage()
  }
  const idToken = sessionStorage.getItem('ID_TOKEN')
  return idToken
}

const getAccessToken = () => {
  return sessionStorage.getItem('ACCESS_TOKEN')
}

const getUserId = () => {
  return sessionStorage.getItem('USER_ID')
}

const setIDToken = (token: string) => {
  sessionStorage.setItem('ID_TOKEN', token)
}

const setAccessToken = (token: string) => {
  sessionStorage.setItem('ACCESS_TOKEN', token)
}

const setUserId = (userId: string) => {
  sessionStorage.setItem('USER_ID', userId)
}

const checkUserLoggedIn = () => {
  return isTokenValid('ID_TOKEN')
}

const updateTokensToStorage = async () => {
  try {
    const authSession = await fetchAuthSession()
    const idToken = authSession.tokens?.idToken?.toString() || ''
    const accessToken = authSession.tokens?.accessToken?.toString() || ''
    const userSub = authSession.userSub!
    setUserId(userSub)

    const username = authSession.tokens?.accessToken?.payload.username
    const email = authSession.tokens?.idToken?.payload.email

    MixpanelManager.identify(userSub)
    MixpanelManager.people?.set({
      $name: username,
      $email: email,
    })

    setIDToken(idToken)
    setAccessToken(accessToken)
  } catch (error) {
    console.error(error)
  }
}

const isTokenValid = (TOKEN: string) => {
  let token = sessionStorage.getItem(TOKEN)
  if (token) {
    let decodedToken = jwtDecode(token)
    let currentDate = new Date()

    // JWT exp is in seconds
    if (decodedToken.exp && decodedToken.exp * 1000 < currentDate.getTime()) {
      console.log('Token expired.')
      return false
    } else {
      return true
    }
  } else return false
}

export {
  getIDToken,
  getAccessToken,
  setIDToken,
  setAccessToken,
  getUserId,
  setUserId,
  updateTokensToStorage,
  checkUserLoggedIn,
}
